import CreateNode from 'utils/createNode'
const _default = 'width=device-width,initial-scale=1.0'

class Scaler {
    constructor(base, auto) {
        this.base = base

        this.getViewPort()
        // 首次自动运行
        this.run()
        // 自动监听
        auto && this.bindEv()
    }
    getViewPort() {
        // 获取viewport元素
        this.$vp = document.head.querySelector('meta[name="viewport"]')
        if (!this.$vp) {
            // 没找到，直接创建一个
            this.$vp = CreateNode('meta', {
                name: 'viewport',
                content: 'width=device-width,initial-scale=1.0'
            }, document.head)
        }
    }
    setViewPort(content) {
        // 设置viewport大小和缩放值
        this.$vp.setAttribute('content', content || _default)
    }
    getScale() {
        // 计算缩放比例
        const width = document.documentElement.clientWidth
        return width > this.base ? 1 : width / this.base
    }
    run() {
        // 清除上次任务
        clearTimeout(this.timer)

        // 重置viewport
        this.setViewPort()
        // 宏任务等待120毫秒后设置新的viewport值
        this.timer = setTimeout(() => {
            const scale = this.getScale()
            // 拿到的缩放值为1，无需缩放
            if (scale === 1) return
            // 设置缩放
            this.setViewPort(`width=${this.base},minimum-scale=${scale},maximum-scale=${scale},user-scalable=no,minimal-ui`)
        }, 120)
    }
    bindEv() {
        // 转屏事件绑定
        this.evFn = () => this.run()
        window.addEventListener('orientationchange', this.evFn, false)
    }
    destory() {
        if (!this.evFn) return

        // 注销转屏事件绑定
        window.removeEventListener('orientationchange', this.evFn, false)
        // 重置viewport
        this.setViewPort()
    }
}

export default (base = 750, auto = true) => new Scaler(base, auto)